import { render } from "./single-message-page.vue?vue&type=template&id=d77fc352&lang=pug"
import script from "./single-message-page.vue?vue&type=script&lang=js"
export * from "./single-message-page.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__